import { getBrand } from "core/utils/getBrand";
import { useRegion } from "./useRegion";

export function useBrandCountryCode() {
  const { brandTwoLetterCode } = getBrand();
  const region = useRegion();
  return `${brandTwoLetterCode}${region}`.toUpperCase();
}
